'use strict';

require('../core/core');
require('../../modules/pagination/pagination');
require('../../modules/forms/forms');

require('../../models/user/userMembership');
require('../../models/club/club');

require('../../forms/inviteUserForm');
require('../../forms/clubEditForm');
require('../../forms/themes/inviteUser/inviteUser.theme');

require('../../helpers/show-modal-message/show-modal-message');

require('../fos_user/directives/unique-user');

angular.module('far.club', [
	'ngTouch',
	'ngMessages',
	'angularFileUpload',
	'ui.select',
	'ui.bootstrap',
	'dekky.pagination',
	'dekky.forms',
	'far.models.userMembership',
	'far.models.club',
	'far.core',
	'far.forms.inviteUserForm',
	'far.forms.clubEditForm',
	'dekky.forms.themes.inviteUser',
	'far.helpers.showModalMessage',
	'far.fos_user.uniqueUser'
]).value('formsConfig', {
	theme: '/dekky.forms/themes/far'
});